import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Translate } from '@travel/translation';
import { lazyWithSuspense } from '@travel/utils';

import { setChat } from 'store/chat/actions';

import type { Query } from 'ReservationsList-Types';

import Layout from '../../components/Layout';
import Banner from './components/Banner';
import OtherServices from './components/OtherServices';
import ReservationTab from './components/ReservationTab';

// Load dialogs client-only to avoid SSR hydration mismatches
const QRCodeDialogue = lazyWithSuspense(() => import('./components/QRCodeDialog'));
const FurusatoCouponSearchDialog = lazyWithSuspense(
  () => import('./components/FurusatoCouponSearchDialog'),
);
const FurusatoErrorDialog = lazyWithSuspense(() => import('./components/FurusatoErrorDialog'), {
  ssr: false,
});
const MobileCouponSearchDialog = lazyWithSuspense(
  () => import('./components/MobileCouponSearchDialog'),
);
const MobileErrorDialog = lazyWithSuspense(() => import('./components/MobileErrorDialog'));

type Props = {
  path: string;
  filter?: string;
  query: Query;
};

const ReservationList = (props: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setChat({
        isExists: true,
        url: 'https://img.travel.rakuten.co.jp/image/tr/hs/sptop/bhTpM/',
        text: <Translate id="Booking_List.Bottom_Floating.Chatbot.First" />,
      }),
    );
  }, [dispatch]);

  return (
    <Layout data-testid="reservation-list">
      <Banner />
      <ReservationTab {...props} />
      <OtherServices />
      <QRCodeDialogue />
      <FurusatoCouponSearchDialog />
      <FurusatoErrorDialog />
      <MobileCouponSearchDialog />
      <MobileErrorDialog />
    </Layout>
  );
};

export default ReservationList;
